import { render, staticRenderFns } from "./Dongguan.vue?vue&type=template&id=66300bbd&scoped=true&"
import script from "./Dongguan.vue?vue&type=script&lang=js&"
export * from "./Dongguan.vue?vue&type=script&lang=js&"
import style0 from "./Dongguan.vue?vue&type=style&index=0&id=66300bbd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66300bbd",
  null
  
)

export default component.exports